export { default } from './Snackbar';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Snackbar/index.js
// module id = 703
// module chunks = 0